import {
  IApiResponse,
  IGetAllPermissionResponse,
  IGetByIdRequest,
  IGetPermissionByRoleRequest,
  IGetUserByIdResponse,
  IPaginationRequest,
  IUpdateRolePermissionRequest,
} from "model";
import { PREFIX } from "utils/Const";
import { BaseApiService } from "./BaseApiService";

const prefix = PREFIX.permission;
const getUrl = (url: string) => {
  return `${prefix}/${url}`;
};

const URL_GET_ALL_PERMISSIONS = getUrl("get-all-permissions");
const URL_GET_PERMISSION_BY_ROLE = getUrl("get-permissions-by-role");
const URL_GET_PERMISSION_BY_CURRENT_USER = getUrl(
  "get-permissions-by-current-user"
);
const URL_UPDATE_ROLE_PERMISSIONS = getUrl("update-role-permissions");
const URL_GET_WAREHOUSE_BY_USER = getUrl("get-warehouse-by-user");

class PermissionApiService extends BaseApiService {
  public getAllPermissions = (request: IPaginationRequest) =>
    this.get<IGetAllPermissionResponse>(URL_GET_ALL_PERMISSIONS, {
      params: request,
    });
  public getPermissionByRole = (request: IGetPermissionByRoleRequest) =>
    this.get<IGetUserByIdResponse>(URL_GET_PERMISSION_BY_ROLE, {
      params: request,
    });
  public getPermissionByCurrentUser = () =>
    this.get(URL_GET_PERMISSION_BY_CURRENT_USER);

  public updateRolePermission = (request: IUpdateRolePermissionRequest) =>
    this.put<IUpdateRolePermissionRequest, IApiResponse<string>>(
      URL_UPDATE_ROLE_PERMISSIONS,
      request
    );
  public getWarehouseByUser = (request: IGetByIdRequest) =>
    this.delete<IGetByIdRequest>(URL_GET_WAREHOUSE_BY_USER, {
      params: request,
    });
}

export default new PermissionApiService();
